"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValuationInitializerDefinition = void 0;
/**
 * Initializes valuation in case of existing token.
 */
const WidgetInitializerPlugin_1 = require("auto-widget-framework/src/Plugin/WidgetInitializer/WidgetInitializerPlugin");
const WidgetInitializerPluginDefinition_1 = require("auto-widget-framework/src/Plugin/WidgetInitializer/WidgetInitializerPluginDefinition");
const RepositoryTypes_1 = require("../../../../Enum/RepositoryTypes");
const Collection_1 = require("../../../../Model/Collection");
const StepTypes_1 = require("../../../../Enum/StepTypes");
const IContainerInjection_1 = require("auto-widget-framework/src/Container/IContainerInjection");
const Mixin_1 = require("auto-widget-framework/src/Util/Mixin");
const EndpointError_1 = require("../../../../Error/EndpointError");
const ValuationNotFoundError_1 = require("../../../../Error/ValuationNotFoundError");
class ValuationInitializer extends WidgetInitializerPlugin_1.default {
    constructor(definition, repositoryFactory, returnLinkService) {
        super(definition);
        this.repositoryFactory = repositoryFactory;
        this.returnLinkService = returnLinkService;
    }
    static create(definition, container) {
        return new this(definition, container.get('factory.repository'), container.get('return_link'));
    }
    loadData(state, valuation) {
        state.setValuation(valuation);
        state.setToken(valuation.getToken());
        if (valuation.getVrm() &&
            valuation.getMileage() &&
            valuation.getStatus() &&
            valuation.getToken() &&
            valuation.getVehicle()) {
            state.setVehicle(valuation.getVehicle());
            state.setVrm(valuation.getVrm());
            state.setToken(valuation.getToken());
            state.setMileage(valuation.getMileage());
            state.setStatus(valuation.getStatus());
        }
        if (valuation.getCustomer()) {
            state.setCustomer(valuation.getCustomer());
        }
    }
    initialize(config, state) {
        //First try and get the token from the url then if it doesn't exist from the config
        let token = this.returnLinkService.getReturnTokenFromUrl() || config.getToken();
        let shouldClone = config.isCloneValuationEnabled();
        let promise;
        if (!token) {
            return Promise.resolve();
        }
        this.valuationRepo = this.repositoryFactory.create(RepositoryTypes_1.RepositoryTypes.VALUATION, { config });
        state.setVehicleSearchPreloadRequired(true);
        if (shouldClone) {
            promise = this.valuationRepo.clone(token)
                .then((valuation) => {
                this.loadData(state, valuation);
                let vehicle = valuation.getVehicle();
                let vehicleIsNotEmpty = Object.keys(vehicle).length > 0;
                if (vehicleIsNotEmpty) {
                    state.setVehicles(new Collection_1.default([vehicle]));
                    state.setStepId(StepTypes_1.StepTypes.SELECT_VEHICLE);
                }
                else {
                    state.setStepId(StepTypes_1.StepTypes.SEARCH_VEHICLE_VRN_ONLY);
                }
            });
        }
        else {
            promise = this.valuationRepo.get(token)
                .then((valuation) => {
                this.loadData(state, valuation);
                if (valuation.isCompleted()) {
                    state.setStepId(StepTypes_1.StepTypes.VALUATION);
                }
            });
        }
        return promise.catch((error) => {
            if (EndpointError_1.default.is(error) && error.getResponseStatus() === 404) {
                throw new ValuationNotFoundError_1.default(token);
            }
            throw error;
        });
    }
}
exports.default = ValuationInitializer;
exports.ValuationInitializerDefinition = new WidgetInitializerPluginDefinition_1.default({
    id: "valuation_initializer",
    class: ValuationInitializer,
    priority: 50
});
Mixin_1.default(ValuationInitializer, IContainerInjection_1.default);
